import _ from 'lodash';
import { makeCancellableAPIRequest } from 'restAPI';

const RepositoryAPI = {
    getAssetStats(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/repos/count"
        )
    },
    getRiskyRepos(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/repos/risky",
        )
    },
    getMappingStats({ gitReposStatusType } = {}) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/repos/details",
            {
                params: { gitReposStatusType }
            }
        )
    },
    getRepositories({ repoStatusType, sort, page, size, ...params } = {}) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git",
            {
                params: { repoStatusType, sort, page, size, ...params }
            }
        )
    },
    getRepositoryCoverage() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/coverage",
        )
    },
    getGitHubTeams( ignore, mapped, unMapped, page, size ) {
        const searchParams = new URLSearchParams({page, size});
        searchParams.append("ignore", ignore);
        const checkMapped = _.compact([mapped, unMapped]);
        if(checkMapped.length === 1){
            searchParams.append("mapped", mapped || !unMapped);
        }
        const finalQryParams = searchParams.toString();
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/git/teams?${finalQryParams}`,
        )
    },
    getTopUsers(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/topUsers"
        )
    },
    getOverPrivilegedUsers(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/overPrivilegedUsers"
        )
    },
    gitIgnore( type, id, ignore, note ) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/${type}/ignore/${id}?ignore=${ignore}&note=${note}`,
        )
    },
    ignoreOverPrivilegedUsers(id, ignore) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/overPrivilegedUser?userId=${id}&ignore=${ignore}`,
        )
    },
    getBranches(params, showDefaultMessage = false) {
        const { type, name: query, ...restParams } = params;
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/git/${type}/branches`,
            {
                params: {...restParams, query}
            },
            showDefaultMessage
        )
    },
    getRepoDistribution() {
        return makeCancellableAPIRequest(
            "GET",
            "user/tools/git/repos/distribution"
        )
    },
    getMCCBranches(repoId, params = {}, showDefaultMessage = false) {
        const { query, ...restParams } = params;
        const payload = query ? { query, ...restParams } : restParams;
        return makeCancellableAPIRequest(
            "GET",
            `/api/tools/git/repo/${repoId}/mcc-branches`,
            {
                params: payload
            },
            showDefaultMessage
        )
    },
    triggerMCCSync(repoId, payload, showDefaultMessage = false) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/git/repo/${repoId}/mcc-sync`,
            {
                data: payload
            },
            showDefaultMessage
        )
    }
}

export default RepositoryAPI;